import { loadStripe } from "@stripe/stripe-js";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripeApiKey = process.env.REACT_APP_STRIPE_API_KEY;
const disableStripe = process.env.REACT_APP_ENABLE_STRIPE === "false";

export const stripePromise =
  !disableStripe && stripeApiKey ? loadStripe(stripeApiKey) : null;
